import { render, staticRenderFns } from "./ConfiguracaoUsuarioPage.vue?vue&type=template&id=39839d3e"
import script from "./ConfiguracaoUsuarioPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoUsuarioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports